import { COUNTRY_CODES } from '@savgroup-front-common/constants';

import {
  GEOCODE_ADDRESS_FROM_DATA_GOUV_TYPES,
  GeocodeAddressFromDataGouvResponse,
} from '@savgroup-front-common/core/api/DataGouv';
import { Place, PLACE_TYPE } from '../PlacesAutocomplete.types';

export const adaptDataGouvFeaturesToPlaces = (
  response: GeocodeAddressFromDataGouvResponse,
): Place[] => {
  return (
    response.features
      ?.filter(
        (feature) =>
          ![
            GEOCODE_ADDRESS_FROM_DATA_GOUV_TYPES.STREET,
            GEOCODE_ADDRESS_FROM_DATA_GOUV_TYPES.MUNICIPALITY,
          ].includes(feature.properties.type),
      )
      .map((feature) => {
        const { properties } = feature;

        return {
          id: properties.id,
          originType: PLACE_TYPE.GOUV,
          description: `${properties.housenumber} ${properties.street}, ${properties.city}, France`,
          mainText: properties.name,
          secondaryText: `${properties.city}, France`,
          data: {
            countryCode: COUNTRY_CODES.FR,
            streetNumber: properties.housenumber,
            street: properties.street,
            city: properties.city,
            postalCode: properties.postcode,
          },
        };
      }) ?? []
  );
};
